/**
 * Submit button so that player's can confirm their response. When they do that, the round will enter an interval 
 * where the right answers and score is shown. The button in this state then changes to show a "next round" label.
 */

import * as React from 'react';

interface Props {
    isRoundInterval: boolean;
    roundCount: number;
    roundIndex: number;
    submit(): void;
}

export default class Submit extends React.Component<Props, {}> {

    /**
     * Render a button with an appropriate label depending on the round state.
     */
    public render(): JSX.Element {
        let buttonText: string;
        if (this.isFinished()) {
            buttonText = 'Finish';
        } else {
            buttonText = this.props.isRoundInterval ? 'Next' : 'Submit';
        }
        return (
            <div className="quiz-submit">
                <div className="button" onClick={this.props.submit}>{buttonText}</div>
            </div>
        );
    }

    /**
     * See if the quiz is about to finish. This will change the button label.
     */
    private isFinished(): boolean {
        return this.props.isRoundInterval && (this.props.roundIndex === this.props.roundCount - 1);
    }

}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/globals/components/submit/submit.tsx